import React from 'react';
import FormikRadioButtons from 'src/components/formik-radio-buttons';

/**
 *
 * @requires formik.values.communityCollegeInfo
 */

const LowIncomeInput = () => (
  <FormikRadioButtons
    name="communityCollegeInfo.lowIncome"
    options={[
      {value: 'Yes', label: 'Yes'},
      {value: 'No', label: 'No'},
      {value: "Don't Know", label: "Don't Know"},
    ]}
    legendText={
      <>
        <p>Are you receiving need-based financial aid at your current college?</p>
        <span>
          Some scholarship programs are limited to students who demonstrate financial need.
          Answering this question accurately will give you the most transparency into scholarship
          opportunities!
        </span>
      </>
    }
  />
);

export default LowIncomeInput;
